import { FC } from "react";
import Chip from "@mui/material/Chip";

// SIMS-5801 — per-row matrix cell:
//   accessed → teal
//   not accessed → neutral gray
const TEAL = "#1D9E75";
const GRAY = "#9E9E9E";

interface AccessedBadgeProps {
	accessed: boolean;
}

const AccessedBadge: FC<AccessedBadgeProps> = ({ accessed }) => (
	<Chip
		label={accessed ? "Accessed" : "Not accessed"}
		size="small"
		sx={{
			bgcolor: accessed ? TEAL : GRAY,
			color: "#fff",
			fontWeight: 600,
			minWidth: 100,
		}}
	/>
);

export default AccessedBadge;
